import { apiRequest } from "../utils/useAPIRequest";
import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";

const useGetAudits = (auditsTableQuery, filterQuery, searchQuery) => {
  const query = useMemo(() => {
    if (searchQuery) {
      return `${auditsTableQuery}&${filterQuery}&search=${searchQuery}`;
    } else if (filterQuery) {
      return `${auditsTableQuery}&${filterQuery}`;
    } else {
      return auditsTableQuery;
    }
  }, [filterQuery, auditsTableQuery, searchQuery]);

  return useQuery({
    queryKey: ["getAudits", query],
    queryFn: () => {
      return apiRequest({
        url: `/audit?${query}`,
        method: "get",
      });
    },
    keepPreviousData: true,
  });
};
const useGetAdminAudits = (adminAuditsTableQuery, filterQuery, searchQuery) => {
  const query = useMemo(() => {
    if (searchQuery) {
      return `${adminAuditsTableQuery}&${filterQuery}&search=${searchQuery}`;
    } else if (filterQuery) {
      return `${adminAuditsTableQuery}&${filterQuery}`;
    } else {
      return adminAuditsTableQuery;
    }
  }, [filterQuery, adminAuditsTableQuery, searchQuery]);

  return useQuery({
    queryKey: ["getAdminAudits", query],
    queryFn: () => {
      return apiRequest({
        url: `/audit/admin?${query}`,
        method: "get",
      });
    },
    keepPreviousData: true,
  });
};

export default {
  useGetAudits,
  useGetAdminAudits,
};
